import type { AccountController, AccountSnapshot } from "@hq/client";
import { useSyncExternalStore } from "react";

const local: AccountSnapshot = { phase: "signed_out" };
const subscribeLocal = () => () => {};
const getLocalSnapshot = () => local;

export function useAccountSnapshot(account?: AccountController) {
  return useSyncExternalStore(
    account?.subscribe ?? subscribeLocal,
    account?.getSnapshot ?? getLocalSnapshot,
  );
}
